import React, { useState } from "react";
import { Card, Form, Input, Button, Alert, Typography } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { apiLogin } from "../api/auth";
import { useTranslation } from "../i18n/LanguageProvider";
import LanguageSwitcher from "../i18n/LanguageSwitcher";
import { DISABLED_FALLBACK_ROUTE, isPathnameDisabled } from "../config/disabledModules";

const { Title } = Typography;

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const { t } = useTranslation();

  async function onFinish(values) {
    setErr("");
    setLoading(true);

    try {
      await apiLogin(values.username, values.password);

      // Never bounce back into a disabled module, not even via a remembered "from" path.
      const requested = location.state?.from;
      const redirectTo =
        requested && !isPathnameDisabled(requested)
          ? requested
          : DISABLED_FALLBACK_ROUTE;

      navigate(redirectTo, { replace: true });
    } catch (e) {
      setErr(e?.message || t("login.failed"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <Card className="w-full max-w-md">
        <div className="px-4 py-6">
          <div className="mb-4 flex justify-end">
            <LanguageSwitcher tone="light" />
          </div>

          <Title level={3} className="!mb-6 text-center">
            {t("login.title")}
          </Title>

          {err && (
            <Alert type="error" showIcon message={err} className="mb-4" />
          )}

          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
              name="username"
              label={t("login.username")}
              rules={[{ required: true }]}
            >
              <Input autoComplete="username" />
            </Form.Item>

            <Form.Item
              name="password"
              label={t("login.password")}
              rules={[{ required: true }]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              className="!h-11"
            >
              {t("login.submit")}
            </Button>
          </Form>
        </div>
      </Card>
    </div>
  );
}